import { render, staticRenderFns } from "./SelfServicePanel.vue?vue&type=template&id=72008589&scoped=true"
import script from "./SelfServicePanel.vue?vue&type=script&lang=js"
export * from "./SelfServicePanel.vue?vue&type=script&lang=js"
import style0 from "./SelfServicePanel.vue?vue&type=style&index=0&id=72008589&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72008589",
  null
  
)

export default component.exports